import request from '@/utils/request'
const BASE_URL = '/user'

export default {
  login(data) {
    return request({
      url: BASE_URL + '/login',
      method: 'post',
      data
    })
  },
  savePwd(data) {
    return request({
      url: BASE_URL + '/savepwd',
      method: 'post',
      data
    })
  }
}